import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { dispatch } from '@store';
import { actions as actionsAuth } from '@store/auth';
import { actions as actionsGrids } from '@store/grids';
import { history } from '@history';
import { AuthService, http, PopupsService } from '@services';
import { ConstantsUtil } from '@utils';
import { buildOAuthInitUrl, getPopupErrorMessage } from '@helpers';
import { ApiResponse, Popups, Routes } from '@enums';
import { i18n } from '@localization';

var ErrorInterceptor = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(error) {
    var errorObject, errorRedirect, errorInModal, dontHandleError, waitErrorModal, redirectToErrorPage, _error$response, checkBlobError, killSession, _error$response2, data, jsonData, _error$response3, _error$response4, _error$response5, _error$response5$data, _error$response6, _error$response6$data, _error$response7, _error$response7$data, _error$response8, _error$response8$data, _error$response9, _error$response9$data, _error$response10, config, resp, _data, convertedError;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            errorObject = {
              status: undefined,
              cause: undefined,
              name: '',
              stack: '',
              message: ''
            };
            errorRedirect = error.config.errorRedirect;
            errorInModal = error.config.errorInModal;
            dontHandleError = error.config.dontHandleError;
            waitErrorModal = error.config.waitErrorModal;

            redirectToErrorPage = /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(error) {
                var convertedError, errorPopup;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        convertedError = getPopupErrorMessage(error);

                        if (errorRedirect && !errorInModal) {
                          history.push(Routes.Error, convertedError);
                        }

                        if (!errorInModal) {
                          _context.next = 7;
                          break;
                        }

                        errorPopup = PopupsService.open(Popups.Default, {
                          header: '',
                          body: convertedError.message,
                          acceptButton: i18n.t('components.popups.clear')
                        });

                        if (!waitErrorModal) {
                          _context.next = 7;
                          break;
                        }

                        _context.next = 7;
                        return errorPopup;

                      case 7:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function redirectToErrorPage(_x2) {
                return _ref2.apply(this, arguments);
              };
            }();

            if (!error.response) {
              _context2.next = 58;
              break;
            }

            checkBlobError = function checkBlobError(error) {
              if (error instanceof Blob) {
                return error.text();
              }

              return undefined;
            };

            killSession = function killSession() {
              AuthService.removeTokenLocalStorage();
              dispatch(actionsAuth.logoutUserSuccess());
              dispatch(actionsGrids.closeAllGrids());
              history.push(Routes.Events);
            };

            if (!((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) instanceof Blob)) {
              _context2.next = 17;
              break;
            }

            _context2.next = 12;
            return checkBlobError(error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data);

          case 12:
            data = _context2.sent;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            jsonData = JSON.parse(data !== null && data !== void 0 ? data : '{}'); // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment

            errorObject = _objectSpread({}, jsonData);
            _context2.next = 33;
            break;

          case 17:
            _context2.t0 = _objectSpread;
            _context2.t1 = _objectSpread({}, error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data);
            _context2.t2 = {};
            _context2.t3 = error === null || error === void 0 ? void 0 : (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.status;
            _context2.t4 = (error === null || error === void 0 ? void 0 : (_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : (_error$response5$data = _error$response5.data) === null || _error$response5$data === void 0 ? void 0 : _error$response5$data.Error) || (error === null || error === void 0 ? void 0 : (_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : (_error$response6$data = _error$response6.data) === null || _error$response6$data === void 0 ? void 0 : _error$response6$data.error);
            _context2.t6 = (error === null || error === void 0 ? void 0 : (_error$response7 = error.response) === null || _error$response7 === void 0 ? void 0 : (_error$response7$data = _error$response7.data) === null || _error$response7$data === void 0 ? void 0 : _error$response7$data.message) || (error === null || error === void 0 ? void 0 : (_error$response8 = error.response) === null || _error$response8 === void 0 ? void 0 : (_error$response8$data = _error$response8.data) === null || _error$response8$data === void 0 ? void 0 : _error$response8$data.detail) || (error === null || error === void 0 ? void 0 : (_error$response9 = error.response) === null || _error$response9 === void 0 ? void 0 : (_error$response9$data = _error$response9.data) === null || _error$response9$data === void 0 ? void 0 : _error$response9$data.Detail);

            if (_context2.t6) {
              _context2.next = 27;
              break;
            }

            _context2.next = 26;
            return checkBlobError(error === null || error === void 0 ? void 0 : (_error$response10 = error.response) === null || _error$response10 === void 0 ? void 0 : _error$response10.data);

          case 26:
            _context2.t6 = _context2.sent;

          case 27:
            _context2.t5 = _context2.t6;

            if (_context2.t5) {
              _context2.next = 30;
              break;
            }

            _context2.t5 = '';

          case 30:
            _context2.t7 = _context2.t5;
            _context2.t8 = {
              status: _context2.t3,
              name: _context2.t4,
              message: _context2.t7,
              stack: ''
            };
            errorObject = (0, _context2.t0)(_context2.t1, _context2.t2, _context2.t8);

          case 33:
            if (dontHandleError) {
              _context2.next = 56;
              break;
            }

            _context2.t9 = error.response.status;
            _context2.next = _context2.t9 === ApiResponse.InvalidToken ? 37 : _context2.t9 === ApiResponse.Unauthorized ? 50 : _context2.t9 === ApiResponse.NotFound ? 52 : 54;
            break;

          case 37:
            config = error === null || error === void 0 ? void 0 : error.config;

            if (config !== null && config !== void 0 && config.doNotRefreshIntercept) {
              _context2.next = 48;
              break;
            }

            config.doNotRefreshIntercept = true;
            _context2.next = 42;
            return AuthService.memoizedRefreshAccessToken();

          case 42:
            resp = _context2.sent;
            _data = resp === null || resp === void 0 ? void 0 : resp.data;

            if (_data.accessToken && _data.refreshToken) {
              AuthService.setTokenLocalStorage(_data.accessToken, _data.refreshToken);
            } else {
              killSession();
            }

            return _context2.abrupt("return", http(config));

          case 48:
            killSession();

          case 49:
            return _context2.abrupt("break", 56);

          case 50:
            // killSession();
            PopupsService.open(Popups.Default, {
              header: '',
              body: i18n.t('components.popups.unauthorizedBody'),
              acceptButton: i18n.t('components.popups.unauthorizedButton')
            }).then(function () {
              var _error$config, _requestData$place, _requestData$place2;

              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-assignment
              var requestData = JSON.parse((error === null || error === void 0 ? void 0 : (_error$config = error.config) === null || _error$config === void 0 ? void 0 : _error$config.data) || '{}');
              document.location.replace(buildOAuthInitUrl({
                zoneId: requestData === null || requestData === void 0 ? void 0 : (_requestData$place = requestData.place) === null || _requestData$place === void 0 ? void 0 : _requestData$place.zoneId,
                id: requestData === null || requestData === void 0 ? void 0 : (_requestData$place2 = requestData.place) === null || _requestData$place2 === void 0 ? void 0 : _requestData$place2.id
              }));
            })["catch"](function () {// ToDo: error handling
            });
            return _context2.abrupt("break", 56);

          case 52:
            history.push(Routes.NotFound);
            return _context2.abrupt("break", 56);

          case 54:
            _context2.next = 56;
            return redirectToErrorPage(errorObject);

          case 56:
            _context2.next = 67;
            break;

          case 58:
            if (!error.request) {
              _context2.next = 64;
              break;
            }

            // The request was made but no response was received
            errorObject.message = ConstantsUtil.errors.NETWORK_ERROR;
            _context2.next = 62;
            return redirectToErrorPage(errorObject);

          case 62:
            _context2.next = 67;
            break;

          case 64:
            // Something happened in setting up the request that triggered an Error
            errorObject.message = ConstantsUtil.errors.NETWORK_SETTING_ERROR;
            _context2.next = 67;
            return redirectToErrorPage(errorObject);

          case 67:
            convertedError = getPopupErrorMessage(errorObject);
            return _context2.abrupt("return", Promise.reject(convertedError));

          case 69:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function ErrorInterceptor(_x) {
    return _ref.apply(this, arguments);
  };
}();

export { ErrorInterceptor };